import styles from './RadioButton.scss';
import { useCallback } from 'react';

export default function RadioButton({ value, name, label, checked, onChange }) {
  const handleChange = useCallback(() => onChange(value), [value, onChange]);

  function handleKeyDown(evt) {
    if (evt.keyCode === 32) {
      handleChange(value);
    }
  }
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  return (
    <div className={styles.controlContainer}>
      <input
        type="radio"
        id={`${name}-${value}`}
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      <label
        className={styles.label}
        htmlFor={`${name}-${value}`}
        onKeyDown={handleKeyDown}
        onClick={handleChange}
      >{label}</label>
    </div>
  );
}
